import type { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const planRoutes: Array<RouteObject> = [
  {
    id: "measuring-concept",
    path: "*",
    lazy: async () => convertRouteModule(await import("./plan")),
    children: [
      {
        id: "energy-system",
        path: "*",
        lazy: async () => convertRouteModule(await import("./application")),
        children: [
          {
            path: ":prosumerId",
            lazy: async () => convertRouteModule(await import("./prosumer-config")),
            children: [
              {
                path: "latest-data",
                lazy: async () => {
                  const { clientLoader } =
                    await import("./prosumer-config/data-editing/measurement-value-modal");
                  return { loader: clientLoader };
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
